<template>
  <div>
    <b-card-body>
      <b-card class="saveContainer">
        <b-form submit.stop.prevent="saveXML">
          <b-row v-if="loaded">
            <b-col sm="12">
              <div class="tableTxt">
                <div>
                  <span class=""><b>{{$t('saveScenarioFilter')}}</b></span>
                  <b-input class="mt-1 input-pentagro" :placeholder="$t('placeholderSaveScenarioFilter')" v-model="filter"/>
                </div>
              </div>
              <br/>             
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div v-if="this.scenarioList.length == 0">{{$t('scenarioListMessage')}}<br></div>
              <div v-else>
                <div class="row second-row">
                  <div class="col-12 table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">                    
                    <table class="table table-hover table-sm">
                      <thead class="thead-dark">
                        <th scope="col">{{$t('savedScenariosHeader')}}</th>
                      </thead>
                      <tbody class="">
                        <template>                          
                          <tr v-for="scenario in this.filteredScenario" :key="scenario.id">
                            <td 
                              v-if="scenario.name != 'PADRAO' || (scenario.name == 'PADRAO' && user.Name.toUpperCase() == 'PENTAGRO')"
                              :id="'scenario-'+scenario.id" 
                              @click="selectedScenario(scenario.name, scenario.id)" 
                              class="text-truncate tableTxt" 
                              style="max-width: 200px;">
                              {{ scenario.name }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <br/>             
            </b-col>
          </b-row>
          <b-row v-if="loaded">
            <b-col sm="12">
              <div class="tableTxt">
                <span><b>{{$t('selectedScenarioSaveScenario')}}</b></span>
                <div class="inputGroup">
                  <b-form-input id="enterNewCenario" class="mt-1 input-pentagro" type="text" v-model="name" />
                </div>
              </div>
              <br/>             
            </b-col>
          </b-row>
          <b-row v-else class="waitTxt">{{$t('waitingaDataBaseSaveScenario')}}</b-row>
          <b-row class="groupBtn">
            <img
              id="saveScenario"
              class="float-right"
              src="@/assets/salvar.png"
              style="margin-left: 30px;"
              :title="$t('saveScenarioButtom')"
              alt="Salvar cenário"
              @click="checkSaveXML"
            />
            <img
              id="closeModalExportScenario"
              class="float-right"
              src="@/assets/sair.png"
              style="margin-left: 30px;"
              :title="$t('exit')"
              alt="Sair"
              @click="cancelSave"
            />
          </b-row>
          <b-modal id="confirmSaveXML" ok-variant="danger" :ok-title="$t('yes')" :cancel-title="$t('no')" @ok="saveXML">{{$t('saveScenarioConfirmMessage')}}</b-modal>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";
import { mapState } from "vuex";
import GetNameFromXml from "./getNameFromXml";

export default {
  name: "SaveScenario",

  props: [ "openByActiveOnline", "eventSaveOk" ],

  computed: mapState(["user"]),

  data: function() {
    return {
      xml: {},
      scenarioList: [],
      name: "",
      loaded: false,
      filter: "",
      filteredScenario: []
    };
  },
  watch: {
    filter() {
      this.filteredScenario = this.scenarioList.filter(scenario => {
        const scenarioName = scenario.name.toUpperCase();
        const filter = this.filter.toUpperCase();
        if (scenarioName.includes(filter))
          return scenario;
      })
    }
  }, 
  methods:{   
    checkXML(){
      if (!this.xml || this.xml.scenario == "" && this.xml.scenarioResult == "") {
        showError(this.$t('nenhum-cenario-carregado'))
          this.$bvModal.hide('modalSaveScenario') 
        return       
      }     
      this.loadScenariosList()
    },

    cancelSave(){
      if(this.openByActiveOnline)
          this.$emit("eventSaveOk", false)

      this.$bvModal.hide('modalSaveScenario')
    },

    loadScenariosList() {
      const url = `${urlMainAPI}/getsavedsimulationscenario`
      axios.get(url)
        .then( res => {
          this.scenarioList = res.data.sort((a, b) => (a.name > b.name) ? 1 : (a.name === b.name) ? ((a.id > b.id) ? 1 : -1) : -1 )
          console.log('res.data', res.data)
          this.filteredScenario = this.scenarioList
          this.name = this.xml.name
          let scenario = this.filteredScenario.find(s => s.name == this.name)
          this.loaded = true
          setTimeout(() => {if(scenario) this.selectedScenario(scenario.name, scenario.id)}, 100)
        })    
        .catch()
    },

    async checkSaveXML(){
      let checkName = this.scenarioList.filter( x => x.name == this.name)
      if (checkName.length > 0 && this.openByActiveOnline) {
        if(await this.saveXML())
          this.$emit("eventSaveOk", true)
        else
          this.$emit("eventSaveOk", false)
      }
      else if (checkName.length > 0 ){
        this.$bvModal.show('confirmSaveXML')
      }
      else if (this.name == ""){
        showError(this.$t('campo-com-preenchimento-obrigatorio'))
        return
      }else {
        this.saveXML()
      }
    },

    async saveXML(){
      this.name = this.name.replace(/\//g, "-").replace(/[^a-z0-9/-]/gi, "");

      let saveSucess = false;
      let obj = {}
      obj.name = this.name
      obj.scenario = this.xml.scenario
      obj.scenarioResult = this.xml.scenarioResult
      defaultSuccess(this.$t('salvando-o-cenario') + this.name)
      
      if(this.name.toLocaleUpperCase() == "PADRAO" && this.user.Name.toUpperCase() != "PENTAGRO") {
        showError(this.$t('nao-e-possivel-salvar-sobre-o-cenario-padrao-insira-outro-nome'));
        return;
      }
      

      const url = `${urlMainAPI}/savesimulationscenario`
      await axios
        .post(url, obj)
        .then( res => {
          this.$store.commit("setScenarioName", this.name)
          defaultSuccess(res.data)
          this.confirmed = false;

          let xml = {
            name: obj.name,
            nameXml: GetNameFromXml(JSON.stringify(obj.scenario)),
            scenario: obj.scenario,
            scenarioResult: obj.scenarioResult,
            scenarioObjectStructure: this.xml.scenarioObjectStructure,
          }
          
          localStorage.xml = JSON.stringify(xml)
          this.$bvModal.hide('modalSaveScenario')
          saveSucess = true;
        })    
        .catch()

        return saveSucess;
    },

    selectedScenario(name, id){
      this.name = name
      defaultSuccess(this.$t('cenario') +" "+`${name}`+" "+ this.$t('selecionado'))
      this.filteredScenario.forEach(s => {
        let el = document.getElementById("scenario-"+s.id)
        if(el)
          el.style.backgroundColor = "#fff"
      })
      let el = document.getElementById("scenario-"+id);
      if(el)
        el.style.backgroundColor = "#8885"
    },

    getXmlName(){
      if(this.$store.state.xml){
        this.xml = this.$store.state.xml   
        this.name = this.xml.name
        console.log('this.xml', this.xml)
        this.checkXML();
      }
      else{
        setTimeout(this.getXmlName, 1000)
      }
    }
  },

  mounted() {    
    this.getXmlName()
  },

  destroyed() {
    if (this.openByActiveOnline) {
          this.$emit("eventSaveOk", false)
    }
  },
};
</script>

<style scoped>
.saveContainer {
  max-width: 600px;
}

.second-row {
  height: 180px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.inputGroup{
  display: flex;
}

.tableTxt{
  font-size: 0.8em;
}

.tableTxt:hover {
  cursor: pointer;
}

table {
  border-collapse: initial;
  border-spacing: initial; 
}

.waitTxt {
  justify-content: center;
  /* font-weight: bold; */
  background: black;
  color: white;
  margin-bottom: 10px;
}

.my-custom-scrollbar {
  height: 180px;
  overflow: auto;
}

.my-custom-scrollbar th {
  position: sticky; 
  top: 0;
}

img {
  max-height: 35px;
}
</style>
